import {CabinetSourceError} from "./model";
import type {AccountLifecycle, ConsultationOrders, UserProfile, WalletView} from "./ports";

export class UnavailableUserProfile implements UserProfile {
  async read(): Promise<never> { throw unavailable("profile"); }
  async update(): Promise<never> { throw unavailable("profile"); }
  async uploadAvatar(): Promise<never> { throw unavailable("profile"); }
  async clearAvatar(): Promise<never> { throw unavailable("profile"); }
  async changePassword(): Promise<never> { throw unavailable("profile"); }
  async requestEmailVerification(): Promise<never> { throw unavailable("profile"); }
  async requestPhoneVerification(): Promise<never> { throw unavailable("profile"); }
  async confirmPhoneVerification(): Promise<never> { throw unavailable("profile"); }
}

export class UnavailableWalletView implements WalletView {
  async read(): Promise<never> { throw unavailable("wallet"); }
}

export class UnavailableConsultationOrders implements ConsultationOrders {
  async list(): Promise<never> { throw unavailable("orders"); }
}

export class UnavailableAccountLifecycle implements AccountLifecycle {
  async previewDeletion(): Promise<never> { throw unavailable("account"); }
  async confirmDeletion(): Promise<never> { throw unavailable("account"); }
}

function unavailable(source: ConstructorParameters<typeof CabinetSourceError>[0]): CabinetSourceError {
  return new CabinetSourceError(source);
}
